import { ChangeDetectorRef, Component, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { TIMES30 } from 'core/date/hours-mins';
import { WithDisposableSubject } from 'core/mixins/with-disposable-subject';
import { isNilOrEmpty } from 'helpers';

export interface DayTimeModel {
  day: DayOfWeek;
  time: string;
}

@Component({
  selector: 'app-day-time-input',
  templateUrl: './day-time-input.component.html',
  providers: [
    { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => DayTimeInputComponent), multi: true }
  ]
})
export class DayTimeInputComponent extends WithDisposableSubject()
  implements ControlValueAccessor {

  timeOptions = TIMES30.map(t => t);

  /**
   *
   */
  constructor(private cd: ChangeDetectorRef) {
    super();
  }

  day: DayOfWeek;
  time: string;

  private _onTouchedCallback = () => { };
  private _onChangeCallback = () => { };

  get value() {
    if (isNilOrEmpty(this.day)) {
      return null;
    }

    return {
      day: this.day,
      time: this.time
    };
  }

  writeValue(obj: { day: any; time: any }): void {
    this.day = obj?.day;
    this.time = obj?.time;
    this.cd.markForCheck();
  }

  onTimeChanged(time: string) {
    this.time = time;
    this.handleDataChanged();
  }

  dayChanged(day: DayOfWeek) {
    this.day = day;
    if (isNilOrEmpty(day)) {
      return this.onTimeChanged(null);
    }
    if (isNilOrEmpty(this.time)) {
      return this.onTimeChanged(this.timeOptions[0].value);
    }
    this.handleDataChanged();
  }

  registerOnChange(fn: any): void {
    this._onChangeCallback = () => fn(this.value);
  }

  registerOnTouched(fn: any): void {
    this._onTouchedCallback = () => fn(this.value);
  }

  setDisabledState?(isDisabled: boolean): void {
  }

  handleDataChanged() {
    this.cd.markForCheck();
    if (this._onChangeCallback) {
      this._onChangeCallback();
    }
  }

  handleTouched() {
    if (this._onTouchedCallback) {
      this._onTouchedCallback();
    }
  }
}
